<template>
    <v-navigation-drawer
        app
        permanent
        right
        :mini-variant="miniDrawer"
        light
        class="sideBar"
    >
        <template v-slot:prepend>
            <v-list-item class="px-2">
                <v-menu
                    offset-y
                    bottom
                    origin="center center"
                    transition="scale-transition"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item-avatar v-bind="attrs" v-on="on">
                            <v-img src="/media/avatar/avatar.png"></v-img>
                        </v-list-item-avatar>
                    </template>

                    <v-list class="p-0">
                        <v-list-item @click="logOut" class="py-0 px-12">
                            <v-list-item-title>تسجيل خروج</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-list-item-title class="pl-3 pt-1">{{
                    userName
                }}</v-list-item-title>
                <!-- <v-btn icon @click.stop="miniDrawer = !miniDrawer">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn> -->
            </v-list-item>
        </template>
        <v-list dense>
            <router-link
                v-slot="{ href, navigate, isActive }"
                v-for="item in mainNavs"
                :key="item.title"
                :to="item.link"
                class="position-relative"
            >
                <a
                    :href="href"
                    @click="navigate"
                    v-if="isRoled(item) && item.isRoled"
                >
                    <v-list-item
                        class="py-1 position-relative"
                        :class="{ 'active activeOrange': isActive }"
                        link
                    >
                        <v-list-item-icon>
                            <img
                                :src="item.icon"
                                :alt="item.title"
                                width="22"
                            />
                            <img
                                v-if="isActive"
                                src="/media/svg/aside-icon/active-musk.svg"
                                class="list-item-musk"
                            />
                        </v-list-item-icon>
                        <v-list-item-content class="text-right pr-3 pt-4">
                            <v-list-item-title>{{
                                item.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </a>
            </router-link>
            <v-list-group
                dir="ltr"
                color="IMThemeGray"
                v-if="isRoled(settingRoles) && settingRoles.isRoled"
            >
                <template v-slot:activator>
                    <v-list-item dir="rtl" class="py-1 px-0" link>
                        <v-list-item-icon class="mr-4">
                            <img
                                :src="settingRoles.icon"
                                :alt="settingRoles.title"
                                width="22"
                            />
                        </v-list-item-icon>
                        <v-list-item-content class="text-right pr-3 pt-4">
                            <v-list-item-title>{{
                                settingRoles.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <router-link
                    v-slot="{ href, navigate, isActive }"
                    v-for="item in subNavs"
                    :key="item.title"
                    :to="item.link"
                    class="position-relative overflow-hidden"
                >
           
                    <a :href="href" @click="navigate">
                        <v-list-item
                            dir="rtl"
                            class="py-1 pr-3"
                            :class="{ 'active activeOrange': isActive }"
                            style="background: rgba(0, 0, 0, 0.2)"
                            link
                        >
                            <v-list-item-icon>
                                <img
                                    :src="item.icon"
                                    :alt="item.title"
                                    width="22"
                                />
                                <img
                                    v-if="isActive"
                                    src="/media/svg/aside-icon/active-musk.svg"
                                    class="list-item-musk"
                                />
                            </v-list-item-icon>
                            <v-list-item-content class="text-right pr-3 pt-4">
                                <v-list-item-title>{{
                                    item.title
                                }}    </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </a>
                </router-link>
            </v-list-group>
        </v-list>
        <template v-slot:append>
            <div v-if="!miniDrawer">
                <v-divider></v-divider>
                <div
                    dir="ltr"
                    class="pb-4 pt-3 d-flex align-items-center justify-content-center"
                >
                    <small class="pr-2 pt-3 text-IMTGray">Powered by</small>
                    <img
                        src="/media/logo/blue-horizontal.png"
                        alt="elkood"
                        width="100"
                    />
                </div>
            </div>
        </template>
    </v-navigation-drawer>
</template>
<style lang="scss" scoped>
a {
    text-decoration: none !important;
}
.v-sheet.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.07),
        0px 1px 10px 0px rgba(0, 0, 0, 0.06);
}
</style>
<style lang="scss">
.sideBar {
    ::-webkit-scrollbar {
        background-color: rgb(238, 238, 238);
        width: 10px;
        border-radius: 15px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #ff5f01;
        border-radius: 15px;
        width: 5px;
    }
}
.v-list-group__header {
    flex-direction: row-reverse !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
}
.list-item-musk {
    position: absolute;
    right: calc(100% - 16px);
    top: 50%;
    transform: translateY(-50%);
    height: 34px;
    width: 46px;
}
.v-navigation-drawer__border {
    background: transparent !important;
}
.activeOrange {
    filter: invert(29%) sepia(107%) saturate(2322%) hue-rotate(0deg)
        brightness(118%) contrast(191%);
}
</style>
<script>
import jwtService from "@/service/jwt.service";
import { mapActions, mapGetters } from "vuex";
export default {
    name: "EK-aside",
    data: () => ({
        miniDrawer: true,
        drawer: true,
        roles: null,
        settingRoles: {
            title: "الإعدادات",
            icon: "/media/svg/aside-icon/setting.svg",
            role: ["Admin"],
            isRoled: false
        },
        mainNavs: [
            {
                title: "الرئيسية",
                icon: "/media/svg/aside-icon/home.svg",
                link: "/dashboard",
                role: ["Admin"],
                isRoled: false
            },
            {
                title: "المشتركون",
                icon: "/media/svg/aside-icon/shop.svg",
                link: "/shop",
                role: ["Admin", "Shop"],
                isRoled: false
            },
          
            {
                title: "طلبات الاشتراك",
                icon: "/media/svg/aside-icon/add-shop.svg",
                link: "/shop-request",
                role: ["Admin", "Shop"],
                isRoled: false
            },
            {
                title: "الاشتراكات",
                icon: "/media/svg/aside-icon/subscription.svg",
                link: "/subscription",
                role: ["Admin", "Subscription"],
                isRoled: false
            },
            {
                title: "الإعلانات والعروض",
                icon: "/media/svg/aside-icon/media.svg",
                link: "/ad",
                role: ["Admin", "Offer"],
                isRoled: false
            },
            {
                title: "الإشعارات",
                icon: "/media/svg/aside-icon/notification.svg",
                link: "/notification",
                role: ["Admin"],
                isRoled: false
            },
            {
                title: "سجل الرسائل",
                icon: "/media/svg/aside-icon/sms.svg",
                link: "/smsRecords",
                role: ["Admin", "Shop"],
                isRoled: false
            },
            {
                title: "مشتركو التطبيق",
                icon: "/media/svg/aside-icon/account.svg",
                link: "/user-info",
                role: ["Admin"],
                isRoled: false
            },
            {
                title: "تواصل معنا",
                icon: "/media/svg/aside-icon/contact.svg",
                link: "/contact",
                role: ["Admin", "Contact"],
                isRoled: false
            },
            {
                title: "التقارير",
                icon: "/media/svg/aside-icon/report.svg",
                link: "/report",
                role: ["Admin"],
                isRoled: false
            }
        ],
        subNavs: [
            {
                title: "الحسابات",
                icon: "/media/svg/aside-icon/account.svg",
                link: "/account"
            },
            {
                title: "التصنيفات",
                icon: "/media/svg/aside-icon/category.svg",
                link: "/category"
            },
            {
                title: "الإعدادات العامة",
                icon: "/media/svg/aside-icon/global-setting.svg",
                link: "/setting"
            },
            {
                title: "حول",
                icon: "/media/svg/aside-icon/about.svg",
                link: "/about"
            }
        ]
    }),
    computed: {
        ...mapGetters(["mini", "userName"])
    },
    mounted() {
        this.roles = jwtService.getRoles();
    },
    methods: {
        ...mapActions(["logout"]),
        logOut() {
            this.logout();
            this.$router.push("/log-in");
        },
        isRoled(item) {
            setTimeout(() => {
                if (typeof this.roles == "string") {
                    item.isRoled = item.role.indexOf(this.roles) != -1;
                } else {
                    let flag = false;
                    this.roles.forEach((role, index) => {
                        if (item.role.indexOf(role) != -1) {
                            flag = true;
                        }
                        if (index == this.roles.length - 1) {
                            item.isRoled = flag;
                        }
                    });
                }
            });
            return true;
        }
    },
    watch: {
        mini(newVal) {
            this.miniDrawer = newVal;
        },
        miniDrawer(newVal) {
            this.$store.dispatch("setMiniDrawer", newVal);
        }
    }
};
</script>
